import React from "react";
// Components
import Navbar from "../../components/Navbar";
import MotivosRejeicaoSVG from "../../assets/navbar/Convenios_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";
import { useHistory, useLocation } from "react-router-dom";
import ListMotivosRejeicao from "../../components/ListMotivosRejeicao";

export default function MotivosRejeicaoList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={MotivosRejeicaoSVG} />
            <div>
              <S.Title>Motivos de Rejeicao</S.Title>
              <S.Description>
                Cadastro de motivos de rejeição para o Front de Crédito
              </S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-motivos-rejeicao")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />

            <S.Image src={MotivosRejeicaoSVG} />
          </S.AddNew>
        </S.Header>

        <ListMotivosRejeicao
          filter={params.get("filter") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
